module.exports = __webpack_public_path__ + "static/img/047_TO8_1569_og.32b3554.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/047_TO8_1569_og.jpg
// module id = DcLn
// module chunks = 0